<template>
  <div class="rank" ref="container">
    <div class="nav acea-row row-around row-middle">
      <div
        @click="changenav(index, item)"
        class="item"
        :class="{ on: index == status }"
        v-for="(item, index) in navlist"
        :key="index"
      >
        {{ item.name }}
      </div>
    </div>
    <img class="rank_bg" src="@assets/images/rank_bg.png" alt="" />
    <div class="list">
      <div class="item title acea-row row-middle row-between-wrapper">
        <div class="left">排名</div>
        <div class="middle">用户</div>
        <div class="right">业绩</div>
      </div>
      <div
        class="item acea-row row-between-wrapper row-middle"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="left">
          <img
            class="grade"
            v-if="item.grade == 1"
            src="@assets/images/medal01.png"
            alt=""
          />
          <img
            class="grade"
            v-if="item.grade == 2"
            src="@assets/images/medal02.png"
            alt=""
          />
          <img
            class="grade"
            v-if="item.grade == 3"
            src="@assets/images/medal03.png"
            alt=""
          />
          <span v-if="item.grade > 3">{{ item.grade }}</span>
        </div>
        <div class="middle acea-row row-middle">
          <img :src="item.user.avatar" alt="" />
          <div>
            <div class="phone">{{ item.user.phone }}</div>
          </div>
        </div>
        <div class="right">{{ item.total_num }}份</div>
      </div>
      <div class="nolist" v-if="!list.length">暂无数据</div>
    </div>
  </div>
</template>
<script>
import { ranking, rankingLevel } from "../../api/user";
export default {
  name: "rank",
  data() {
    return {
      navlist: [],
      navindex: 0,
      list: [],
      status: 0,
      page: 1,
      loading: false,
      loadend: false,
      limit: 10,
      navid: 0
    };
  },
  mounted() {
    this.getnav();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getlist();
    });
  },
  methods: {
    changenav(index, item) {
      this.status = index;
      this.page = 1;
      this.list = [];
      this.loading = false;
      this.loadend = false;
      this.getlist(item.id);
    },
    getnav() {
      rankingLevel()
        .then(res => {
          this.navlist = res.data;
          this.getlist(res.data[0].id);
        })
        .catch(res => {
          console.log(res);
        });
    },
    getlist(id) {
      this.navid = id;
      if (this.loading) return;
      if (this.loadend) return;
      let data = {
        page: this.page,
        limit: this.limit,
        level: this.navid
      };
      this.loading = true;
      ranking(data)
        .then(res => {
          this.list = this.list.concat(res.data);
          this.page++;
          this.loading = false;
          this.loadend = this.limit > res.data.length;
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.rank {
  .nav {
    background: #ffffff;
    height: 12vw;
    line-height: 8vw;
    text-align: center;
    .item {
      &.on {
        color: #0e98fd;
        border-bottom: 2px solid #0e98fd;
      }
    }
  }
  .rank_bg {
    width: 100%;
  }
  .list {
    background: #ffffff;
    padding-bottom: 3vw;
    .item {
      height: 15.47vw;
      border-bottom: 0.5px solid #e1e1e1;
      .left {
        width: 13.73vw;
        text-align: center;
        .grade {
          width: 8vw;
          height: 8vw;
        }
      }
      .middle {
        width: 60vw;
        color: #333;
        font-size: 3.47;
        padding-right: 5vw;
        img {
          width: 9.87vw;
          height: 9.87vw;
          border-radius: 50%;
          margin-right: 3vw;
        }
      }
      .right {
        width: 24vw;
        height: 7.47vw;
        line-height: 7.47vw;
        color: #fff;
        background: #0e98fd;
        border-radius: 4vw 0 0 4vw;
        text-align: center;
        font-size: 3.47vw;
      }
    }
    .title {
      height: 11.73vw;
      border-bottom: 0.5px solid #e1e1e1;
      .right {
        background: transparent;
        color: #666;
      }
      .left {
        color: #666;
      }
      .middle {
        color: #666;
        padding-left: 15vw;
      }
    }
    .nolist {
      text-align: center;
      line-height: 20vw;
    }
  }
}
</style>
